module.exports = __WEBPACK_EXTERNAL_MODULE_4__;


/*****************
 ** WEBPACK FOOTER
 ** external {"amd":"react","commonjs":"react"}
 ** module id = 4
 ** module chunks = 0
 **/